// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"styles_imageWrapper__JHkLK","absoluteIcon":"styles_absoluteIcon__d7Shh"};